import get from "lodash/get";
import { convertDateForBackend } from "../../../../../../Utils";
import KEYS from "../../../../../../Component/DynamicForm/KEYS";
import moment from "moment";

const init = {
  value: null,
  required: false,
  options: [],
  placeholder: "",
  label: "label_name",
  helperText: "",
  defaultValue: "",
  iserr: () => {},
  showAllErr: false,
};

function getOptArr({ arr, displaynamekey, displayvaluekey }) {
  return arr.map((element) => ({
    ...element,
    displayname: element[displaynamekey],
    displayvalue: element[displayvaluekey],
  }));
}

export const apioutputconverter = (fields) => fields.map((field) => ({
    defaultfieldtypeid: field.defaultfieldtypeid,
    subexpensefieldid: field.subexpensefieldid,
    isfuelconfig: field.isfuelconfig,
    fuelfieldtypeid: field.fuelfieldtypeid,
    fueltypeid: field.fuelfieldtypeid != 0 ? get(get(field, "fieldvalue", [])
    .find((x) => x.subexpensefieldvalueid == get(field, "value", "")), "fueltypeid", null) : 0,
    fieldvalue:
      field.fielddatatypid === KEYS.Select
      ? get(get(field, "fieldvalue", [])
      .find((x) => x.subexpensefieldvalueid == get(field, "value", "")), "valuename", null)
      : field.fielddatatypid === KEYS.Date ? convertDateForBackend(get(field, "value", "")) : get(field, "value", ""),
  }));

// const initfieldvalue = [{ valuename: "", subexpensefieldvalueid: "" }];

export function outputconverter(fields) {
  const getValue = (field) => [{
    valuename: field.value, subexpensefieldvalueid: "",
  }];
    // if (field && field.valuename) {
    //   return field && field.fieldvalue && field.fieldvalue.map((val) => ({ ...val, valuename: field.value }));
    // }
    // return initfieldvalue.map((val) => ({ ...val, valuename: field && field.value ? field.value : null }));
  // };

  return fields.map((field) => ({
    ...field,
    fieldvalue: field.fielddatatypid !== KEYS.Select && field.fielddatatypid !== KEYS.MultiSelect ? getValue(field) : field.fieldvalue,
  }));
}

export const inputconverter = ({ arr, categorylimit, ispolicylimit }) => arr.map((field) => ({
    ...init,
    ...field,
    label: field.fieldname,
    typeid: field.fielddatatypid,
    id: field.subexpensefieldid,
    categorylimit,
    ispolicylimit,
    required: field.isrequired,
    value:
      field.fielddatatypid === KEYS.MultiSelect
        ? getOptArr({
            arr: get(field, "fieldvalue", []).filter((opt) => opt.isselected),
            displaynamekey: "valuename",
            displayvaluekey: "subexpensefieldvalueid",
          })
        : field.fielddatatypid === KEYS.Select
        ? get(get(field, "fieldvalue", []).find((opt) => opt.subexpensefieldvalueid == field.value), "subexpensefieldvalueid", null)
        : get(field, `value`, ""),
    options:
      field.fielddatatypid === KEYS.Select || field.fielddatatypid === KEYS.MultiSelect
        ? getOptArr({
            arr: get(field, "fieldvalue", []),
            displaynamekey: "valuename",
            displayvaluekey: "subexpensefieldvalueid",
          })
        : [],
    iserr: ({ fielddata }) => {
      let flag = false;
      if (fielddata.showAllErr && fielddata.required) {
          flag = !fielddata.value;
      }
      console.log('categorylimit: ', categorylimit);
      if (fielddata.defaultfieldtypeid == 2 && fielddata.value && categorylimit) {
        flag = fielddata.value > fielddata.categorylimit;
      }

      return flag;
    },
    helperText: field.defaultfieldtypeid == 2 && categorylimit ? `${ispolicylimit ? `must be less than policy limit ${categorylimit}` : `must be less than ${categorylimit}`}` : field.defaultfieldtypeid == 1 ? field.maxrequestdate && moment(new Date()).format("YYYY-MM-DD") > field.maxrequestdate && "Invalid expense date" : "",
    errorText: field.defaultfieldtypeid == 2 && categorylimit ? `${ispolicylimit ? `must be less than policy limit ${categorylimit}` : `must be less than ${categorylimit}`}` : field.defaultfieldtypeid == 1 ? field.maxrequestdate && moment(new Date()).format("YYYY-MM-DD") > field.maxrequestdate && "Invalid expense date" : "Please fill required field",
  }));

export const opconverter = () => {};
